import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  ListItem,
} from '@mui/material';

import { ItemSidebar } from '../../../../config/interfaces';
import { setOpenAlertMenu } from '../../../../hooks/actions';

const NavItem = (props: ItemSidebar) => {
  const navigate = useNavigate();
  const {
    href,
    icon,
    title,
    active,
  } = props;
  const colorValue = active ? 'primary' : '#FFF';

  return (
    <ListItem
      disableGutters
      sx={{
        display: 'flex',
        width: '100%',
        mb: 0.5,
        p: 0,
      }}
    >
      <Button
        component="a"
        startIcon={icon}
        disableRipple
        onClick={() => {
          setOpenAlertMenu(false);
          navigate(href);
        }}
        sx={{
          color: colorValue,
          justifyContent: 'flex-start',
          px: 2,
          py: 0.5,
          m: 0,
          fontWeight: 500,
          fontSize: '13px',
          textAlign: 'left',
          textTransform: 'none',
          width: '100%',
          '& .MuiButton-startIcon': {
            color: colorValue,
          },
          '&:hover': {
            color: 'primary',
            background: 'none',
          },
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          {title}
        </Box>
      </Button>
    </ListItem>
  );
};

export default NavItem;
